
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecotrails/[slug]",
      function () {
        return require("private-next-pages/ecotrails/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecotrails/[slug]"])
      });
    }
  